import { createFeature, createReducer, on } from '@ngrx/store';
import { Brand, MetaData } from '@emi/shared/models';
import * as brandActions from './brand-actions';
import * as commonActions from '../common-actions';

export interface BrandState {
    brands: Brand[];
    metadata: MetaData | null;
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const brandFeatureKey = 'brandFilters';

const initialState: BrandState = {
    brands: [],
    metadata: null,
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const brandFeature = createFeature({
    name: brandFeatureKey,
    reducer: createReducer(
        initialState,
        on(brandActions.isLoadingBrands, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(brandActions.getNextPageBrands, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(brandActions.getBrandsSuccess, (state, { brands, metadata, searchText }) => {
            return {
                ...state,
                brands,
                metadata,
                searchText,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(brandActions.updateBrandsSelectionSuccess, (state, { brands, metadata }) => {
            return {
                ...state,
                brands: [...state.brands, ...brands],
                metadata,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(brandActions.getBrandsFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(brandActions.searchBrands, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
